import { Loading } from '@/components/loading/Loading';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';
import { cn } from '@/lib/utils';
import { useBundlesWithProduct } from '@/services/bundles/useProductInBundles';

import { FunctionComponent, Suspense } from 'react';

const UnselectProductErrorModal: FunctionComponent<ModalProps<{ productId: string }>> = props => {
  const ErrorModal = () => {
    const productId = props.props?.productId;
    if (!productId) throw new Error('Missing product id');

    const bundlesWithProduct = useBundlesWithProduct(productId);

    const oneBundleWithProduct = bundlesWithProduct.length === 1;

    return (
      <Card className="w-full p-8 space-y-2">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-bold">Error unselecting product</h1>
        </Modal.Controls>

        <div className={cn(oneBundleWithProduct ? 'space-x-1' : 'flex flex-col')}>
          <span>
            Unable to unselect as this product is contained within
            {oneBundleWithProduct ? ' bundle:' : ' bundles:'}
          </span>
          {oneBundleWithProduct ? (
            <span className="font-medium">{bundlesWithProduct[0].name}</span>
          ) : (
            <div className="font-medium">
              {bundlesWithProduct.map(bundle => (
                <p key={`unselectProductError-${productId}-${bundle.id}`}>{bundle.name}</p>
              ))}
            </div>
          )}
        </div>
      </Card>
    );
  };

  return (
    <Modal className="md:max-w-2xl" {...props}>
      <Suspense fallback={<Loading />}>
        <ErrorModal />
      </Suspense>
    </Modal>
  );
};

export default UnselectProductErrorModal;
